export const addresses = {
  assetStoreProvider: "0x666432Ccb747B2220875cE185f487Ed53677faC9",
  coinProvider: "0xeC1BB74f5799811c0c1Bff94Ef76Fb40abccbE4a",
  colorSchemes: "0xF6a8aD553b265405526030c2102fda2bDcdDC177",
  bitcoinArtProvider: "0x09120eAED8e4cD86D85a616680151DAA653880F2",
  bitcoinToken: "0x3E661784267F128e5f706De17Fac1Fc1c9d56f30",
};
